import { useEffect } from "react";
import { ChangeSocialObjectType } from "../../static/types/changeSocialObjective/changeSocialObjectType";
import useValidation from "../../hooks/useValidation";
import changeSocialObjectValidationSchema from "../../utils/validation/changeSocialObject/changeSocialObjectValidationSchema";

// Fonction utilitaire pour le formatage du texte
const formatObjectText = (text: string): string => {
    // Remplacer tous les sauts de ligne par des espaces
    let formatted = text.replace(/\n/g, '. ');
    
    // Supprimer les espaces multiples et les espaces en début/fin
    formatted = formatted.replace(/\s+/g, ' ').trim();
    
    return formatted;
};

type ChangeSocialObjectProps = {
  checked: boolean;
  labelText: string;
  socialObject: ChangeSocialObjectType;
  changeSocialObject: (partialSocialObject: Partial<ChangeSocialObjectType>) => void;
  onValidationChange: (isValid: boolean) => void;
  showTypeSelect?: boolean;
  showRequiredIndicator?: boolean;
};

export default function ChangeSocialObject({
  checked,
  socialObject,
  changeSocialObject,
  onValidationChange,
  showTypeSelect = true,
  showRequiredIndicator = true,
  labelText,
}: ChangeSocialObjectProps) {

  const { isValid, errors } = useValidation(socialObject, changeSocialObjectValidationSchema);

  useEffect(() => {
    onValidationChange(isValid);
  }, [isValid, onValidationChange]);

  useEffect(() => {
    if( !socialObject.type ) changeSocialObject({type: "extension"})
  }, [])

  const getClassName = (errorField?: string, isSelect?: boolean) =>
    `${isSelect ? "form-select" : "form-control"} ${checked && errorField ? "is-invalid" : ""}`;

  return (
    <div className="tab-content">
      
      {showTypeSelect && (
        <div className="mb-3 row">
          <label htmlFor="type" className="col-sm-2 col-form-label">
            Type {showRequiredIndicator && <strong className="text-danger">*</strong>}
          </label>
          <div className="col-sm-5">
            <select
              className={getClassName(errors.type, true)}
              id="type"
              aria-invalid={!!(checked && errors.type)}
              onChange={(e) => changeSocialObject({ type: e.target.value })}
              value={socialObject.type || ""}
            >
              <option value="extension"> Extension </option>
              <option value="modification"> Modification </option>

            </select>
          </div>
        </div>
      )}

      <div className="mb-3 row position-relative">
        <label htmlFor="objectSocial" className="col-sm-2 col-form-label">
         {labelText} {showRequiredIndicator && <strong className="text-danger">*</strong>}
        </label>
        <div className="col-sm-10">
          <textarea
            className={getClassName(errors.socialObject)}
            id="objectSocial"
            aria-invalid={!!(checked && errors.socialObject)}
            value={socialObject.socialObject || ""}
            onChange={(e) => changeSocialObject({ socialObject: e.target.value })}
            onBlur={(e) => {
              const formattedValue = formatObjectText(e.target.value);
              changeSocialObject({ socialObject: formattedValue });
            }}
          />
          {checked && errors.socialObject && (
            <div className="invalid-feedback">{errors.socialObject}</div>
          )}
        </div>
      </div>
    </div>
  );
}